import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SharedService } from '../../../shared/shared.service';
import { Roles, SweetAlertIcon } from '../../../shared/constants/enum';
import { FeedBackService } from '../../../core/services/feedback.service';
import { LoaderService } from '../../../core/services/loader.service';
import { table_pageSize } from '../../../shared/constants/templatesNames';
import { PageChangeEvent } from '@progress/kendo-angular-grid';

import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { formatDate } from '@angular/common'; // <-- Import formatDate from common
import { NotificationService } from '../../../shared/notification.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-rp-feedback-history',
  templateUrl: './rp-feedback-history.component.html',
  styleUrls: ['./rp-feedback-history.component.scss'],
  standalone: false,
})
export class RpFeedbackHistoryComponent implements OnInit {
  searchText = '';
  selectedDate: any = [];

  listOfFeedBacks: any[] = [];
  filteredFeedbacks: any[] = [];
  pagedFeedbacks: any[] = []; // Store paged data
  currentUser: any;
  projectId: any;
  userRole: any;
  listOfRoles = Roles;
  breadCrumbItems: Array<{}> | undefined;
  filterProjectBillDates: any = [];
  datePickerConfig: Partial<BsDatepickerConfig>;
  loadeedData: boolean = false;
  public pageSize = 5;
  public skip = 0;
  public contentId = 'content-1';
  public total = 1;
  public pageSizes = table_pageSize.pageSizes;
  notificationFeedBack: any;
  private feedbackSubscription: Subscription;
  constructor(
    private router: Router,
    private feedbackService: FeedBackService,
    private sharedService: SharedService,
    private modalService: BsModalService,
    private loaderService: LoaderService,
    private notificationService: NotificationService
  ) {
    this.breadCrumbItems = [{ label: 'Feedback History' }];
    this.notificationFeedBack = history.state.info;
    if (this.notificationFeedBack) {
      this.searchText = this.notificationFeedBack.feedbackName;
    }
    this.feedbackSubscription =
      this.notificationService.feedbackUpdate$.subscribe((data) => {
        this.updateFeedbackPage(data);
      });
    let currentDate = new Date();
    this.datePickerConfig = Object.assign(
      {},
      {
        dateInputFormat: 'DD/MM/YYYY', // Set to dd/MM/yyyy format
        showWeekNumbers: false,
        isAnimated: true,
        containerClass: 'theme-dark-blue',
        maxDate: currentDate,
      }
    );
  }

  updateFeedbackPage(data: any) {
    this.notificationFeedBack = data;
    this.searchText = this.notificationFeedBack.feedbackName;
    this.updateFilteredFeedbacks('filter');
    // Trigger any additional logic needed to refresh the page
  }

  ngOnDestroy() {
    if (this.feedbackSubscription) {
      this.feedbackSubscription.unsubscribe();
    }
  }

  onValueChange(ev: any) {
    if (ev.length == 0) {
      // this.userPageChange({ skip: 0, take: this.pageSize })
      this.updateFilteredFeedbacks('filter');
    }
  }

  preventManualInput(event: KeyboardEvent): void {
    // Prevent all keys except Tab and Arrow keys, which are essential for navigating
    const allowedKeys = [
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
    ];
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault(); // Prevent input
    }
  }
  formatDateRange(dateRange: (Date | null)[]): string {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      const startDate = formatDate(dateRange[0], 'dd/MM/YYYY', 'en-US');
      const endDate = formatDate(dateRange[1], 'dd/MM/YYYY', 'en-US');
      return `${startDate} to ${endDate}`;
    }
    return ''; // Return empty string if the date range is not valid
  }

  ngOnInit() {
    this.loaderService.setLoading(true);
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    this.projectId = this.currentUser?.project?.id;
    this.userRole = this.currentUser?.currentUserRoleDetails?.role;
    this.loadeedData = false;
    if (this.userRole === this.listOfRoles.ADMIN) {
      this.feedbackService.getFeedBackServie(this.projectId).subscribe({
        next: (response) => {
          this.loadeedData = true;
          this.loaderService.setLoading(false);
          if (response.statusCode === 200) {
            this.listOfFeedBacks = response.data;
            this.total = this.listOfFeedBacks.length;
            this.updateFilteredFeedbacks('filter');
          }
        },
        error: (err) => {
          this.loaderService.setLoading(false);
          this.sharedService.showMessageDialog(
            'Failure',
            err,
            SweetAlertIcon.ERROR
          );
        },
      });
    } else {
      this.feedbackService.getSuperAdminFeedBackServie().subscribe({
        next: (response) => {
          this.loaderService.setLoading(false);
          if (response.statusCode === 200) {
            this.listOfFeedBacks = response.data;
            this.total = this.listOfFeedBacks.length;
            this.updateFilteredFeedbacks('filter');
          }
        },
        error: (err) => {
          this.loaderService.setLoading(false);
          this.sharedService.showMessageDialog(
            'Failure',
            err,
            SweetAlertIcon.ERROR
          );
        },
      });
    }
  }

  public onPageChange(e: PageChangeEvent): void {
    this.skip = e.skip;
    this.pageSize = e.take;
    this.updatePagedData(); // 👈 only slice, no re-filter
  }

  clearDate() {
    this.selectedDate = []; // Clear the selected date
    this.updateFilteredFeedbacks('reset');
  }

  openCalendar() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.date');
    dateInput?.dispatchEvent(new Event('click'));
  }

  // 🔹 Filter logic
  updateFilteredFeedbacks2(type: string) {
    if (type !== 'filter') {
      this.selectedDate = [];
      this.searchText = '';
    }
    console.log(this.selectedDate[0]);
    console.log(this.selectedDate[1]);
    this.filteredFeedbacks = this.listOfFeedBacks.filter((item) => {
      let matchesText = this.searchText
        ? item.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
        item.residentialUnit
          .toLowerCase()
          .includes(this.searchText.toLowerCase()) ||
        item.description.toLowerCase().includes(this.searchText.toLowerCase())
        : true;
      console.log(this.selectedDate[0]);
      console.log(this.selectedDate[1]);
      const matchesDate =
        this.selectedDate &&
          Array.isArray(this.selectedDate) &&
          this.selectedDate.length === 2
          ? new Date(item.dateTime) >= new Date(this.selectedDate[0]) &&
          new Date(item.dateTime) <= new Date(this.selectedDate[1])
          : true;

      console.log(matchesDate);

      if (this.notificationFeedBack?.feedbackId) {
        matchesText =
          item.id
            .toLowerCase()
            .includes(this.notificationFeedBack.feedbackId.toLowerCase()) ||
          item.description
            .toLowerCase()
            .includes(this.searchText.toLowerCase());
      }

      return matchesText && matchesDate;
    });

    this.total = this.filteredFeedbacks.length;

    // reset to first page whenever filter applied
    this.skip = 0;
    this.updatePagedData();
  }

  filterFeedback(type: string) {
    console.log(this.selectedDate);

    const isSearchTextEmpty = !this.searchText || this.searchText.trim() === '';
    const isDateEmpty = !this.selectedDate || this.selectedDate.length === 0;

    // Error only when BOTH are empty
    if (isSearchTextEmpty && isDateEmpty) {
      this.sharedService.showMessageDialog(
        'Please enter search text or select a date to search.',
        '',
        SweetAlertIcon.INFO
      );
      return;
    }

    // ✅ Proceed if any one is present
    this.updateFilteredFeedbacks(type);
  }


  updateFilteredFeedbacks(type: string) {
    console.log(this.searchText)

    if (type !== 'filter') {
      this.selectedDate = [];
      this.searchText = '';
    }

    this.filteredFeedbacks = this.listOfFeedBacks.filter((item) => {
      const search = this.searchText?.toLowerCase() || '';

      // ✅ Text filter
      let matchesText = search
        ? item.name?.toLowerCase().includes(search) ||
        item.residentialUnit?.toLowerCase().includes(search) ||
        item.description?.toLowerCase().includes(search)
        : true;

      // ✅ Date filter
      let matchesDate = true;
      if (
        this.selectedDate &&
        Array.isArray(this.selectedDate) &&
        this.selectedDate.length > 0
      ) {
        const startDate = new Date(this.selectedDate[0]);
        let endDate: Date;

        if (this.selectedDate.length === 2) {
          // full range
          endDate = new Date(this.selectedDate[1]);
        } else {
          // single day → endDate = startDate
          endDate = new Date(this.selectedDate[0]);
        }

        // normalize both start and end dates
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);

        const itemDate = new Date(item.dateTime);

        matchesDate = itemDate >= startDate && itemDate <= endDate;
      }

      // ✅ Notification Feedback override
      if (this.notificationFeedBack?.feedbackId) {
        const feedbackId = this.notificationFeedBack.feedbackId.toLowerCase();
        matchesText =
          item.id?.toLowerCase().includes(feedbackId) ||
          item.description?.toLowerCase().includes(search);
      }

      return matchesText && matchesDate;
    });

    this.total = this.filteredFeedbacks.length;
    this.skip = 0;
    this.updatePagedData();
  }

  // 🔹 Pagination slice logic
  updatePagedData() {
    this.pagedFeedbacks = this.filteredFeedbacks.slice(
      this.skip,
      this.skip + this.pageSize
    );
  }
}
